var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6686 10.1387C11.4801 10.5197 11.1171 10.7832 10.6973 10.8452L4.3604 11.7714L8.94452 16.2366C9.24936 16.5337 9.38886 16.9613 9.31653 17.3798L8.2354 23.687L13.9007 20.7071C14.2765 20.5095 14.7273 20.5095 15.1032 20.7071L20.7684 23.687L19.6873 17.3798C19.615 16.96 19.7545 16.5324 20.0593 16.2366L24.6434 11.7714L18.3065 10.8452C17.8867 10.7832 17.5225 10.5197 17.3352 10.1387L14.5026 4.39982L11.6699 10.1387H11.6686ZM9.65236 8.3859L13.3439 0.908441C13.818 -0.0512674 15.1871 -0.0512674 15.6599 0.908441L19.3515 8.3859L27.6052 9.59231C28.6644 9.74732 29.0868 11.0493 28.3195 11.7959L22.3482 17.6123L23.7574 25.8299C23.9382 26.8851 22.8312 27.6899 21.8831 27.1913L14.5013 23.3098L7.1194 27.1913C6.17132 27.6899 5.06436 26.8851 5.24519 25.8299L6.6544 17.6123L0.683025 11.7959C-0.0842246 11.0493 0.33815 9.74732 1.39732 9.59231L9.65107 8.3859H9.65236Z",
    fill: "#2C3439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.484ec77d6110677a1d1cf6680ff589ab.svg";
export { ForwardRef as ReactComponent };